export default "__VITE_ASSET__decc95f3__"